<template>
    <div>
        <img class="download" src="@/assets/images/download.png" alt="" @click="download">
    </div>
</template>

<script>
export default {
    name: 'FromSample',
    components: {},
    props: {
        value: {
            type: Array,
            default: []
        },
        config: {
            type: Object,
            default: {}
        }
    },
    model: {
        event: 'change'
    },
    watch: {

    },
    data() {
        return {
            domain: process.env.VUE_APP_DOMAIN,
        }
    },
    methods: {
        download() {
            if (this.config.file.length > 0) {
                const url = this.domain + '/pub/sample?name=' + encodeURIComponent(this.config.file[0].name) + '&path=' + encodeURIComponent(this.config.file[0].url)
                console.log(url)
                window.open(url, '_blank')
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.download {
    width: 100px;
    max-height: 100%;
    cursor: pointer;
    border: 1px solid #efefef;
    padding: 20px;
    border-radius: 5px;
}
</style>
